const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./girl_washing_dish.gif"),
			class: "image-one imgbox-md washingHands-p14",
			imgdiv: "imageCover bg-white",
		},
		{
			src: images("./outline-lg-white.png"),
			class: "image-one outline-14",
			imgdiv: "imageCover",
		},
		{
			src: images("./text_banner.png"),
			class: "image-one textbox",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text text-center text-p14 textbox textbox-ban",
			textIndivData: [
				{
					textData: "भाँडा माझ्दा पनि बोकिरहिन्।",
					textClass: "m-0 one-line textStyles text-p14a",
					timestamps: [{ start: 0 }, { start: 0.6 }, { start: 1.1 }, { start: 1.4 }, { start: 1.7 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./s14.ogg"),
			delay: 500,
		},
	],
}

export default content
